import { LOCATIONS_CRUD_ACTION_CREATORS } from '../actions/locations_actions';
import { ASSETS_CRUD_ACTION_CREATORS } from '../actions/assets_actions';
import { PURCHASE_ORDERS_CRUD_ACTION_CREATORS } from '../actions/purchase_orders_actions';
import { PURCHASE_REQUESTS_CRUD_ACTION_CREATORS } from '../actions/purchase_requests_actions';
import POPipeLineFilters from '../components/purchase_orders_index_page/POPipelineFIlters';
import PRPipeLineFilters from '../components/purchase_requests_index_page/PRPipelineFilters';
import { nullSafeGetOrElse } from '../utils/DataAccessUtils';
import {
	DEFAULT_SORTER,
	FETCH_DATA_PREFIX_FOR_TARGET_COLLECTION,
	GLOBAL_DEBOUNCE_TIME,
} from '../utils/DataConstants';

import { debounce } from '../utils/PerformanceUtils';
import { CONTRACTORS_CRUD_ACTION_CREATORS } from '../actions/contractors_private_network_actions';
import { WALKTHROUGHS_CRUD_ACTION_CREATORS } from '../actions/walkthroughs_actions';
import { REQUESTS_FOR_PROPOSAL_CRUD_ACTION_CREATORS } from '../actions/requests_for_proposal_actions';
import { SITE_SURVEYS_GROUPED_CRUD_ACTION_CREATORS } from '../actions/site_surveys_grouped_actions';
import { SITE_SURVEYS_LOCATIONANDWALKTHROUGH_CRUD_ACTION_CREATORS } from '../actions/site_surveys_locationandwalkthrough_actions';

const queryString = require('qs');
const defaultPagination = { current: 1, pageSize: 10 };

const entityToPipeLineFilters = {
	supplier: {
		purchase_orders: POPipeLineFilters,
		purchase_requests: PRPipeLineFilters,
		assets: [],
	},
	buyer: {
		assets: [],
	},
};
const entityToCreators = {
	purchase_orders: PURCHASE_ORDERS_CRUD_ACTION_CREATORS,
	purchase_requests: PURCHASE_REQUESTS_CRUD_ACTION_CREATORS,
	locations: LOCATIONS_CRUD_ACTION_CREATORS,
	assets: ASSETS_CRUD_ACTION_CREATORS,
	contractor_private_networks: CONTRACTORS_CRUD_ACTION_CREATORS,
	walkthroughs: WALKTHROUGHS_CRUD_ACTION_CREATORS,
	requests_for_proposal: REQUESTS_FOR_PROPOSAL_CRUD_ACTION_CREATORS,
	'site_surveys/grouped': SITE_SURVEYS_GROUPED_CRUD_ACTION_CREATORS,
	'site_surveys/locationandwalkthrough': SITE_SURVEYS_LOCATIONANDWALKTHROUGH_CRUD_ACTION_CREATORS,
};

const parseURL = (
	handleQueryParams,
	history,
	location,
	preAppliedFilters,
	initialPagination,
	initialSorting,
	initialFilters = {}
) => {
	let pagination = initialPagination || defaultPagination;
	let sorting = initialSorting || DEFAULT_SORTER;
	let filters = { ...preAppliedFilters, ...initialFilters };
	if (handleQueryParams && location) {
		let searchString = location.search;
		if (searchString[0] === '?') {
			searchString = searchString.slice(1);
		}
		const queryParams = queryString.parse(searchString);

		const {
			current = pagination.current,
			pageSize = pagination.pageSize,
			sort_by = sorting.sort_by,
			order = sorting.order,
			...rest
		} = queryParams;

		pagination = { current: parseInt(current), pageSize: parseInt(pageSize) };
		sorting = { sort_by, order };
		filters = {
			...(initialFilters || {}),
			...(rest || {}),
			...preAppliedFilters,
		};
	}
	return { pagination, sorting, filters };
};
export const fetchEntities =
	(userType, entityName, fetchData, refreshCounts) =>
	(
		handleQueryParams,
		history,
		location,
		targetCollectionName,
		preAppliedFilters = {},
		initialPagination,
		initialSorting,
		initialFilters,
		ignoreRefreshCounts
	) =>
	(dispatch, getState) => {
		const { pagination, sorting, filters } = parseURL(
			handleQueryParams,
			history,
			location,
			preAppliedFilters,
			initialPagination,
			initialSorting,
			initialFilters
		);
		dispatch(
			fetchDataCall(userType, entityName, fetchData, refreshCounts)(
				handleQueryParams,
				history,
				null,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				ignoreRefreshCounts
			)
		);
	};
export const updatePaginationEntities =
	(userType, entityName, fetchData, refreshCounts) =>
	(handleQueryParams, history, targetCollectionName, pagination, ignoreRefreshCounts) =>
	(dispatch, getState) => {
		const { sorting, filters } = getState()[entityName][targetCollectionName];
		return dispatch(
			fetchDataCall(userType, entityName, fetchData, refreshCounts)(
				handleQueryParams,
				history,
				null,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				ignoreRefreshCounts
			)
		);
	};

export const updateFiltersEntities =
	(userType, entityName, fetchData, refreshCounts) =>
	(handleQueryParams, history, targetCollectionName, filters, ignoreRefreshCounts) =>
	(dispatch, getState) => {
		const {
			sorting,
			filters: storeFilters,
			pagination,
		} = getState()[entityName][targetCollectionName];
		dispatch(
			fetchDataCall(userType, entityName, fetchData, refreshCounts)(
				handleQueryParams,
				history,
				null,
				targetCollectionName,
				{ ...pagination, current: 1 },
				sorting,
				{
					...storeFilters,
					...filters,
				},
				ignoreRefreshCounts
			)
		);
	};
export const clearFiltersEntities =
	(userType, entityName, fetchData, refreshCounts) =>
	(handleQueryParams, history, targetCollectionName, preAppliedFilters, ignoreRefreshCounts) =>
	(dispatch, getState) => {
		const { pagination } = getState()[entityName][targetCollectionName];
		dispatch(
			fetchDataCall(userType, entityName, fetchData, refreshCounts)(
				handleQueryParams,
				history,
				null,
				targetCollectionName,
				{ ...pagination, current: 1 },
				{ ...DEFAULT_SORTER },
				{ ...preAppliedFilters },
				ignoreRefreshCounts
			)
		);
	};

export const replaceFiltersAndSortingEntities =
	(userType, entityName, fetchData, refreshCounts) =>
	(handleQueryParams, history, targetCollectionName, filters, sorting, ignoreRefreshCounts) =>
	(dispatch, getState) => {
		const { pagination } = getState()[entityName][targetCollectionName];
		dispatch(
			fetchDataCall(userType, entityName, fetchData, refreshCounts)(
				handleQueryParams,
				history,
				null,
				targetCollectionName,
				{ ...pagination, current: 1 },
				sorting,
				filters,
				ignoreRefreshCounts
			)
		);
	};

export const updateSortingEntities =
	(userType, entityName, fetchData, refreshCounts) =>
	(handleQueryParams, history, targetCollectionName, sorting, ignoreRefreshCounts) =>
	(dispatch, getState) => {
		const { filters, pagination } = getState()[entityName][targetCollectionName];
		dispatch(
			fetchDataCall(userType, entityName, fetchData, refreshCounts)(
				handleQueryParams,
				history,
				null,
				targetCollectionName,
				{ ...pagination, current: 1 },
				sorting,
				filters,
				ignoreRefreshCounts
			)
		);
	};

export const refreshFilterCounts =
	(entityName) =>
	(targetCollectionName, filters, fetchData, refreshCounts) =>
	(dispatch, getState) => {
		const finalPipelineFilters = nullSafeGetOrElse(
			`supplier.${entityName}`,
			entityToPipeLineFilters,
			[]
		);
		refreshCounts
			? refreshCounts(filters)
			: finalPipelineFilters.forEach((pf) => {
					dispatch(
						fetchData.countBy(
							{
								...filters,
								statuses: undefined,
								...pf.filter,
							},
							pf.name
						)
					);
			  });
	};

const fetchDataFromServer = (props) => {
	const {
		dispatch,
		additionalParams,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		fetchData,
		ignoreRefreshCounts,
		entityName,
		refreshCounts,
	} = props;
	!ignoreRefreshCounts &&
		dispatch(
			refreshFilterCounts(entityName)(targetCollectionName, filters, fetchData, refreshCounts)
		);
	return dispatch(
		fetchData.read(additionalParams, targetCollectionName, pagination, sorting, filters)
	);
};

const debouncedFetchData = debounce(fetchDataFromServer, GLOBAL_DEBOUNCE_TIME);

const fetchDataCall =
	(userType, entityName, fetchData, refreshCounts) =>
	(
		handleQueryParams,
		history,
		additionalParams,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		ignoreRefreshCounts
	) =>
	(dispatch, getState) => {
		const props = {
			dispatch,
			userType,
			entityName,
			additionalParams,
			targetCollectionName,
			pagination,
			sorting,
			filters,
			ignoreRefreshCounts,
			fetchData,
			refreshCounts,
		};
		if (handleQueryParams) {
			const queryParams = queryString.stringify({
				...{
					current: pagination.current,
					pageSize: pagination.pageSize,
				},
				...sorting,
				...filters,
				...additionalParams,
			});
			history.replace(`${window.location.pathname}?${queryParams}`);
		}

		if (
			targetCollectionName &&
			targetCollectionName.includes(FETCH_DATA_PREFIX_FOR_TARGET_COLLECTION)
		) {
			return fetchDataFromServer(props);
		}
		dispatch(entityToCreators[entityName].updateFilters(filters, targetCollectionName));
		dispatch(entityToCreators[entityName].updatePagination(pagination, targetCollectionName));

		return debouncedFetchData(props);
	};
